import { Link } from 'react-router-dom';
import { getHotDramas } from '@/mocks/dramas';

export default function HotDramas() {
  const hotDramas = getHotDramas().slice(0, 8);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-fire-line text-xl text-accent-500"></i>
            </div>
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
              热门推荐
            </h2>
          </div>
          <Link
            to="/category/guochan"
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {hotDramas.map((drama) => (
            <Link
              key={drama.id}
              to={`/article/${drama.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-3 bg-background-200">
                <img
                  src={drama.coverImage}
                  alt={drama.title}
                  title={`${drama.title} - ${drama.subtitle}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    <i className="ri-star-fill text-[10px]"></i>
                    {drama.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3 pt-8">
                  <span className="text-background-50 text-xs whitespace-nowrap">{drama.updateInfo}</span>
                </div>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {drama.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {drama.cast.slice(0, 3).join(' / ')}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}